<vi-page [sidenavs]="true" [footer]="true">
  <vi-content body>
    <vi-panel main>
      <div class="content" content>
        <div class="links">
          <a
            [routerLink]="[{ outlets: { material: ['mat-select'] } }]"
            class="link"
            routerLinkActive="link--active"
            >Select</a
          >
          <a
            [routerLink]="[{ outlets: { material: ['mat-input'] } }]"
            class="link"
            routerLinkActive="link--active"
            >Input</a
          >
          <a
            [routerLink]="[{ outlets: { material: ['mat-datepicker'] } }]"
            class="link"
            routerLinkActive="link--active"
            >Datepicker</a
          >
          <a
            [routerLink]="[{ outlets: { material: ['mat-textarea'] } }]"
            class="link"
            routerLinkActive="link--active"
            >Textarea</a
          >
          <a
            [routerLink]="[{ outlets: { material: ['mat-button'] } }]"
            class="link"
            routerLinkActive="link--active"
            >Button</a
          >
          <a
            [routerLink]="[{ outlets: { material: ['banner'] } }]"
            class="link"
            routerLinkActive="link--active"
            >Banner</a
          >
          <a
            [routerLink]="[{ outlets: { material: ['pill'] } }]"
            class="link"
            routerLinkActive="link--active"
            >Pill</a
          >
          <a
            [routerLink]="[{ outlets: { material: ['units'] } }]"
            class="link"
            routerLinkActive="link--active"
            >Units</a
          >
        </div>

        <router-outlet name="material"></router-outlet>
      </div>
    </vi-panel>
  </vi-content>

  <vi-dsw-footer footer data-at-footer></vi-dsw-footer>
  <app-sidenav left-sidenav></app-sidenav>
</vi-page>
